import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface IncidentNumberDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const IncidentNumberDialog = ({
  isOpen,
  onClose,
  onContinue,
}: IncidentNumberDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Incident Number Missing</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to close the report without adding one?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Close
        </Button>
        <Button onClick={onContinue} color="primary" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncidentNumberDialog;
